import createComponent from 'styles/fela/createComponent';

const Hr = createComponent(({ theme, height = 1, color = 'divider' }) => ({
  borderBottom: `${height}px solid ${theme.color[color]}`,
}), 'div', ['height', 'color']);

Hr.displayName = 'Hr';

export default Hr;
